import {PublishingStatus} from 'graphql-client/__generated/graphqlGlobalTypes';
import {OptionData} from 'ui-library/menus/MenuConstants';
import {capitalize, constantCaseToWords} from 'util/NameUtil';

export function getPublishingStatusOptionDatas(): Promise<Array<OptionData>> {
  return Promise.resolve(
    [...Object.values(PublishingStatus), 'UNPUBLISHED']
      .filter((publishingStatus) => publishingStatus !== PublishingStatus.SUPERSEDED)
      .map((publishingStatus) => ({
        value: publishingStatus,
        name: capitalize(constantCaseToWords(publishingStatus)),
      }))
  );
}
